// extracted by mini-css-extract-plugin
export default {"tabs":"TabsComponent_tabs__NyhXe","tab":"TabsComponent_tab__rFT1N","active":"TabsComponent_active__6yrnx"};